export const TheatreSeatingIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="24" height="24" rx="6" fill="url(#pattern0_8315_4759)" />
      <defs>
        <pattern
          id="pattern0_8315_4759"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_8315_4759" transform="scale(0.0434783)" />
        </pattern>
        <image
          id="image0_8315_4759"
          width="23"
          height="23"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAIAAABvSEP3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAzpJREFUeNqslLlLY1EUxvNeXvZNmWjG3SiI22SMMaJYiYJooQgB/wMLLbQQbAQbsbYWRAWxElSwsBDEP0BERXErXBkXcN8STd78Xq6TMMU0Ord43HPPued833fOfVJVIKhjqaruc0uSDAaD8vr6arNb1c9mkSSJDIosy7FY7CtZyCDr/sdKZnl/f39+fuZLekxwvry8gBEzGo3ient7E5HhcBgTBom7eo/nu6LouZyWlhYMBom4v7/nckVFhdfrPT8/x+VyuWpqaji8vb3lW1JSUlxcfHV1RXZqaGL4fvwMBALV1dWrq6tEbG9v+/3+zs5OIdbQ0FBRUdHS0hL74+Pjurq6jo4OYGKOjo6WlpZSOFBZpTGKqTGr1Zqbm8s+Ly+PzoFL8MrJyWEDKPbZ2dmE4TKZTJjEJ3qiMTIaDU9PT0dHRzCfnJzc2dm5uLhgv7u7i4kEe3t79GF6enptbQ0XrME1Pj7+8PCg1+tJJcHIZDbCEB/8b25uKEgK3IAihcVioUZKSsrd3R0oiKS42Wwmhc1m06hEVTk+txqwgYGBubm54eHhSCSCFjMzM7OzswjB5a6uLvYjIyMgysjImJqamp+fb29vp4nJTpM+NTW1tbUVzm1tbXa73efzFRQUZGZmNjQ0cDMUCqWnpzc2Nrrd7rKysvLyco/H09zcnGi2pgvvAOTgB/bCwsLKygpF6CUoxsbGzs7OiAPC8vLy4uIih4WFhdCfmJg4PDzkVlIXsj4+PjqdTobF4XAQBE1FURAImcShEALgHKILhTkUunxMHQ54dnd3k2h9fR1q/f39LS0t+/v7l5eX8Ort7YXgxsYGSfv6+gj+FV9U+pg6f6W/vr5ezCXS1tbWDg4OqvFFd6F2cnIizKampp6eHrGH4F9TJ0sydDY3N9kDBFEgzBeaW1tbfBlrXMwRopCReiJSTKb2soUuPBZawzienp6Kd5Sfn280Gg8ODtijAi0D//X1NXeysrIgDllc2o8lqn5kwRayoTnzRijUOCQRBYGDqcQXLsI4ES7NG1WV5OuOr4RJUPL3IcvASZhU+uf/5StLQRGLbP7KHzMSDivub+4/L+lzWXQOq/O3AAMAQY4OOmx8O2gAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};
